<template>
  <div>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button
          class="btn"
          @click="$router.push({ name: 'raw-materials-items-create' })"
        >
          Creer un element
        </button>
      </div>
    </div>
    <hr />
    <div class="row justify-content-between">
      <div class="col d-flex">
        <div class="col-auto">Total Quantite :</div>
        <div class="col">
          <span
            v-if="numberItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded"
          >
            {{ numberItems }}
          </span>
          Élément
        </div>
      </div>

      <div class="col d-flex">
        <div class="col-auto">Quantité totale :</div>
        <div class="col">
          <span
            v-if="totalQuantityItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded"
          >
            {{ totalQuantityItems }}
          </span>
        </div>
      </div>

      <div class="col d-flex">
        <div class="col-auto">Montant Total (TTC*) :</div>
        <div class="col">
          <span
            v-if="totalPriceTTCItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded"
          >
            {{ totalPriceTTCItems }}
          </span>
          DH
        </div>
      </div>
    </div>
    <hr />
    <br />
    <div class="row">
      <div class="col-3">
        <label for="">Fournisseur <span class="text-danger">*</span> </label>
        <select v-model="raw_material.supplier_reference" class="form-select">
          <option value=""></option>
          <option
            v-for="(supplier, index) in suppliers"
            :key="index++"
            :value="supplier.reference"
          >
            {{ supplier.society }}
          </option>
        </select>
      </div>

      <div class="col-3">
        <label for="">
          Bon de Commande Nº <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="raw_material.orderNumber"
          class="form-control"
        />
      </div>

      <div class="col-3">
        <label for="">Date <span class="text-danger">*</span></label>
        <input type="date" v-model="raw_material.date" class="form-control" />
      </div>

    </div>
    <br />

  
    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-8">
       
      </div>
      <div class="col-auto">
        <button
          class="btn btn-success"
          @click="save(raw_material)"
          
        >
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
 
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      raw_material: {
        amountPaid: 0,
        date: new Date().toISOString().split("T")[0] // today's date
      },
    };
  },
  computed: {
    ...mapGetters("rawMaterial", {
      raw_material_items: "getItems",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      numberItems: "numberItems",
    }),
    ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("rawMaterial/store", data);
    },
    async refresh() {
      this.$store.dispatch("rawMaterial/getAllItems");
    },
  },
  async beforeMount() {
    await this.$store.dispatch("rawMaterial/getAllItems");
    await this.$store.dispatch("supplier/getAll");
   
  },
};
</script>
